import { updateQuantityUnit, updateSlabInfoQuantityUnit } from "../../../stateManagement/actions/manageCouponActions";
import store from "../../../stateManagement/store";
import { applyCaseFilter, applyPieceFilter } from "../components/DefineCoupon/MarketDetails/configData";

export let labelMappings: Record<string, string> = {
  "coupon-id-liveCoupon":"Coupon ID",
  "coupon-title-liveOptions":"Coupon Title",
  "coupon-type-liveOptions":"Coupon Type",
  "coupon-type-options-tab": "COUPON DEFINITION",
  "createNewCoupon": "CREATE NEW COUPON",
  "coupon-type-options": "Coupon Type Options",
  "coupon-calculation": "Discount Type",
  "coupon-criteria": "Coupon Criteria",
  "clone" : "Clone",
  "percentage": "Percentage %",
  "value": "Amount Based Discount",
  "free_of_charge_discount": "FOC (Free of Charge) Discount",
  "item_level_coupon": "ITEM LEVEL COUPON",
  "bundle_+_total_order_value": "BUNDLE + TOTAL ORDER VALUE",
  "bundle": "BUNDLE",
  "total_order_value": "TOTAL ORDER VALUE",
  "total_order_welcome": "TOTAL ORDER WELCOME",
  "sku": "SKU",
  "skuGroup": "SKU GROUP",
  "brand": "BRAND",
  "packSize": "PACK SIZE",
  "description": "DESCRIPTION",
  "flavour": "FLAVOUR",
  "supplier": "Distributor Details",
  "distributionChannel": "ASM",
  "pieceSize": "PACK SIZE",
  "pieceSizeDesc": "PACK TYPE",
  "itemClass": "ITEM CLASS",
  "batchCode": "BATCH CODE",
  "itemType": "ITEM TYPE",
  "outletCode": "OUTLET CODE",
  "customGroupCode": "CUSTOM GROUP CODE",
  "RESET_DEPENDENT_DATA":
    "Data below this field would reset. Do you want to continue",
  "addMoreAlert": "Empty template already exist",
  "couponAlreadyPresent": "A Combination of coupon scheme is already present",
  "usability-limits": "USABILITY LIMITS",
  "scheme-playground": "SCHEME PLAYGROUND",
  "market-details": "MARKET DETAILS",
  "product-selection": "Product Selection",
  "applicable-slab": "Applicable Slab(s)",
  "must-buy": "Must Buy",
  "already-editing-another-row":
    "Another Row is already in edit mode. Please Save it first",
  "cannot-delete-while-editing":
    "Cannot perform Delete operation while editing",
  "applicable-slab-empty-template-exist": "Empty Template Aready Present",
  "applicable-slab-qty": "Qty",
  "applicable-slab-value": "Value",
  "quantity-unit-value-piece": "piece",
  "quantity-unit-value-case": "case",
  "piece": "Piece",
  "case": "Case",
  "define-retailer-universe": "Define Retailer Universe",
  "market-filter": "Location Filter",
  "region": "Region",
  "state": "STATE",
  "town": "TOWN",
  "district": "DISTRICT",
  "outlet-filter": "Outlet Filter",
  "distributorDetails": "DISTRIBUTOR DETAILS",
  "salesManager": "SALES MANAGER",
  "asm": "ASM",
  "startDate": "Start Date",
  "endDate": "End Date",
  "outletType": "OUTLET TYPE",
  "channel": "CHANNEL",
  "marketId": "MARKET ID",
  "subChannel": "SUB CHANNEL",
  "outletCategory": "OUTLET CATEGORY",
  "outletDivision": "OUTLET DIVISION",
  "vpoClass": "VPO CLASS",
  "USE_ONCE": "Use once per day ? ",
  "coupon-box-diabled-click-alert":
    "Fill appropriate data to make this section enabled",
  "overalapping-outlet-code": "Overlapping outletcodes have been removed",
  "EMPTY_DATA_IN_MUST_BUY":
    "Select atleast single field for must buy before saving",
  "MUST_BUY_OUT_OF_PRODUCT_SELECTION_RANGE":
    "Must buy product selected is out of products selected in product Selection section",
  "MUST_BUY_BATCHCODE_OVERLAPPING":
    "current selection is already part of previous selected must buys",
  "APPLICABLE_SLAB_RANGE_OVERLAPPING":
    "Current Range is overlapping with other must buy ranges",
  "ALL_SELECTED_IN_PRODUCT_SELECTION":
    "You are trying to define schemes on all products. This will delete all prefined product Selection. Are you sure you want to continue ?",
  "TABS_LOWER_PRIORITY_DATA_RESET":
    "Data of lower tabs would reset. Are you sure want to continue?",
  "PRODUCT_SELECTION_BATCHCODE_OVERLAPPING":
    "New product selection you are trying to add is already part of product Selection. Will cause redundant schemes on a product.",
  "VALIDATION_POPUP_HEADER": "Validation Error(s)",
  "VALIDATION_COUPON_TYPE_OPTIONS": "Coupon Type Options not selected",
  "VALIDATION_CALCULATION_METHOD": "Calculation method not selected",
  "VALIDATION_PRODUCT_BIFURCATION_LIST_EMPTY": "Select atleast a single product",
  "VALIDATION_MUST_BUY_LIST_EMPTY":
    "Must Buy is active . Select atleast a single must buy or Deactivate must buy",
  "VALIDATION_MUST_BUY_OVERLAPPING":
    "Selected Must buy's have overlapping products",
  "VALIDATION_MUST_BUY_OUT_OF_PRODUCTS_SELECTION_RANGE":
    "Selected Must Buy are out of product selection range",
  "VALIDATION_MUST_BUY_MIN_QTY_NOT_FILLED":
    "Min Qty value is missing in selected must buys.",
  "VALIDATION_MUST_BUY_MIN_QTY_NEGITIVE": "Min Qty value cannot be negitive",
  "VALIDATION_SLAB_INFO_LIST_EMPTY":
    "Slab info list is empty. Save atleast a single slab",
  "VALIDATION_START_DATE_INVALID": "Invalid Start Date",
  "VALIDATION_END_DATE_INVALID": "Invalid End Date",
  "VALIDATION_START_DATE_LESS_THAN_END_DATE":
    "Start Date should be less than End Date",
  "COUPON_UPLOADED_SUCCESS": "Coupon Successfully Uploaded",
  "PRODUCT_SELECTION_NOT_REQUIRED_IN_TOV":
    "Product selection is not required in total order value",
  "MUST_BUY_NOT_REQUIRED_IN_ILC": "Must buy is not required in Item Level Coupon",
  "MARKET_DETAILS_RESET_MESSAGE":
    "This will reset data of current selection. Are you sure want to continue?",
  "VALIDATION_DATE_GRETAER_THAN_TODAY": "cannot be less than today",
  "MUST_BUY_NOT_REQUIRED_IN_TOV": "Must buy is not required in Total Order Value",
  "TABS_RESET_OUTLET_AND_MARKET":
    "Data of lower tabs and outlet level would reset. Are you sure want to continue?",
  "TABS_RESET_OUTLET":
    "Data selection in outlet level filter would reset. Are you sure want to continue?",
  "VALUE_QTY_SWITCH_DISABLED_MESSAGE":
    "Quantity is disabled in Total Order Value Schemes",
  "EXCLUSION_LIST_HEADER":
    "Exclusion list (Selected outlet code will be excluded)",
  "INCLUSION_LIST_HEADER":
    "Inclusion list (Selected outlet code will be included)",
  "MUST_BUY_INVALID_UNIT_CHANGE":
    "Unit has already been selected in previous must buy. Delete all the previous must buy to change unit",
  "APPLICABLE_SLAB_INVALID_UNIT_CHANGE":
    "Unit cannot be changed once a slab is created. Delete all the slabs or open all slabs in edit mode to be able to change unit",
  "APPLICABLE_SLAB_UNIT_CHANGE_CONFIRMATION":
    "All the empty slabs will reset. Do you want to continue?",
  "INVALID_FILE_INPUT": "INVALID FILE TYPE. Only accept .xlsx file type",
  "INCLUSION_DISABLED":
    "Inclusion is disabled because you have already uploaded scheme on all outlets",
  "REQUEST_BODY_VALIDATION_FAILED": "Request Body Validation Failed",
  "SLAB_MANDATORY_FIELDS_EMPTY":
    "Please check if all mandatory fields are filled in slabs",
  "SLAB_VALIDATION_FAILED":
    "Please check if correct/complete values are filled in the applicable slabs",
  "ALL_SELECTION_INVALID_IN_ILC":
    "All fields cannot be ALL in ITEM LEVEL COUPON.",
  "POST_COUPON": "Do you really want to post?",
  "volume": "VOLUME",
  "currentMonth": "Current Month",
  "previousMonth": "Previous Month",
  "lastYearSameMonth": "Last Year Same Month",
  "grossRevenue": "Gross Revenue",
  "outletsBilled": "Outlets Billed",
  "over_and_above": "OVER AND ABOVE",
  "DIRECT_TO_REOCCURENCE":
    "You are directly redirected to Reoccurence tab as over and above do not require market details",
  "OVER_AND_ABOVE_BODY_HEADER_TEXT": "API REQUEST",
  "OVER_AND_ABOVE_BODY_CONTENT_HEADER_TEXT": "Request Body",
  "SKIP_MARKET_SELECTION": "Skip Market Selection",
  "EXCLUSION_DISABLED": "Exclusion is disabled ",
  "MARKET_DETAILS_DATA_LOST":
    "Saved data of location , outlet , inclusion and exclusion would be lost",
  "MARKET_DETAILS_DISABLED": "Market Details Disabled",
  "NO_CHANGES_MSG": "No changes detected",
  "CONFIRM_PUBLISH": "Do you really want to publish changes?",
  "DEACTIVATE_CONFIRM": "Do you really want to deactivate?",
  "EDIT_COUPON": "Do you really want to edit in playground mode?",
  "PUBLISH_IN_PLAYGROUND": "Do you really want to publish in playground mode?",
  "SWITCH_OFF_PLAYGROUND_MODE": "Do you really want to discard the data?",
  "coupon-title": "Coupon Title",
  "category":"CATEGORY",
  "usability-limits-tab":"COUPON LIMITS",
  "market-details-tab":"MARKET DETAILS",
  "PERCENTAGE_MAX_AMOUNT":"Enter Max Amount :",
  "INCLUSION_DATA_RESET":"Inclusion list file would be removed. Do you wish to Continue?",
  "PERCENTAGE_MAX_AMOUNT_SUBTITLE" : "(Applicable for percentage calculation method)",
  "INVALID_REQUIRED_FIELD":"Field cannot be empty",
  "ALL_SELECTED_IN_MARKET_SELECTION_MESSAGE":"Do you wish to subject this coupon to entire universe?",
  "MARKET_DETAILS_EMPTY":"Market Details is empty.",
  "CONFIRM_PUBLISH_ON_CLONE":"Do you want to delete the parent coupon?",
  "CONFIRM_PUBLISH_ON_DELETE":"Yes",
  "CONFIRM_PUBLISH_ON_NODELETE":"No",
  "UPLOAD_BANNER":"Upload Banner",
  "IS_OVER_AND_ABOVE":"Make it Over And Above?",
  "cannot-select-locationFilter-while-already-selected-outlet" : "you have already selected outlet filters, please unselect them to select location filters",
  "coupon-title-limit":"Coupon Title can be of 60 characters",
  "outletClass" : "OUTLET CLASS",
  "RECURRENCE_NTH_ORDER_INVALID": "Number of purchases cannot be empty if Order Reset Frequency is set",
  "RECURRENCE_NTH_ORDER_FREQUENNCY_INVALID": "Order Reset Frequency cannot be empty if Number of purchases is set",
  "RECURRENCE_USABILITY_INVALID": "Usability Period cannot be empty if Usability Period Limit is set",
  "RECURRENCE_USABILITY_LIMIT_INVALID": "Usability Period Limit cannot be empty if Usability Period is set",
  "define-nth-purchase": "Define Nth Purchase",
  "usability": "Usability",
  "order-reset-frequency": "Order Reset Frequency",
  "recurrence": "RECURRENCE",
  "active-period": "Active Period",
  "ko-calendar": "Calendar",
  "months": "Months",
  "weeks": "Weeks",
  "days": "Days",
  "n-days": "N Days",
  "normal-calendar": "Normal Calendar",
  "coupon-life": "Maximum Coupon Usage Threshold",
  "date-range-picker": "Date Range:",
  "dates": "Dates",
  "N-days-label": "N days from activation",
  "num-of-purchases": "Number of purchase",
  "usability-limit-error": "Value Cannot be More than Coupon Life",
  "nth-order-error": "Value Cannot be 1",
  "usability-limit-label": "Usability Limit",
  "recurrence-coupon-life-placeholder": "Enter Coupon Usage Threshold",
  "coupon-description-name": "Coupon Description",
  "coupon-description-placeholder": "Write Coupon Description here",
  "recurrence-usability-limit": "Enter Coupon Usability Period Limit",
  "recurrence-nth-order-value": "Enter Coupon Nth Order Purchase Frequency",
  "RECURRENCE_USABILITY_LIMIT_INVALID_ZERO": "Usability Period Limit cannot be 0",
  "RECURRENCE_NOT_SAVED":"You have not Saved the Selected Active Period",
  "COUPON_LIFE_CANNOT_BE_LESS_THAN_USAGE_LIMIT":"Coupon Life Cannot Be Less Than Usage Limit",
  "IS_PERIOD_WELCOME":"Make it Periodic Usability Welcome",
  "COUPON_TIMING":"Coupon Timings",
  "coupon-timings-empty-template-exist":"Empty timing slab aready present",
  "COUPON_TIMING_SLAB_RANGE_OVERLAPPING":"An already saved slab is overlapping with the current slab in coupon timings",
  "COUPON_TIMINGS_SLAB_VALIDATION_FAILED":"Please check if correct/complete values are filled in the coupon timings slabs",
  "START_TIME":"Start Time",
  "END_TIME":"End Time",
  "RECURRENCE_UNAVAILABLE_IN_EDIT_AND_CLONE" :"Recurrence feature is not avaliable in edit/clone mode.You would be redirected to live coupon Data.",
  "Nth_PURCHASE_OPEN_OVER_AND_ABOVE_POPUP":"This will make the coupon Over and above. Do you wish to continue",
  "Nth_SWITCH_CLICK_DISABLED_ALERT_MESSAGE":"Click on switch to open the tab",
  "EMPTY_NTH_PURCHASE_ERROR":"Nth Purchase data is empty.Fill the data to continue or disable the nth purchase section.",
  "NTH_PURCHASE_GREATER_THAN_1_Alert":"Number of purchase should be greater than 1",
  "COUPON_UPDATE_SUCCESS": "Coupon Successfully Updated",
  "MAX_DISCOUNT_CANNOT_BE_NULL": "Max Discount cannot be null in Percentage Coupons.",
  "COUPON_SUMMARY":"CouponSummary"
};

export function updateLabelMappings(tobeAdded: object) {
  labelMappings = {
    ...labelMappings,
    ...tobeAdded,
  };
}

export const COUPON_TYPE_OPTIONS_VALUE = {
  ITEM_LEVEL_COUPON: "item_level_coupon",
  BUNDLE_PLUS_TOTAL_ORDER_VALUE: "bundle_+_total_order_value",
  TOTAL_ORDER_VALUE: "total_order_value",
  TOTAL_ORDER_WELCOME: "total_order_welcome",
  BUNDLE: "bundle",
  OVER_AND_ABOVE: "over_and_above",
};

export let MetaData: Record<string, any> = {
  Incentive_Period:[{
    value : "Monthly",
  },{
    value : "Period",
  },{
    value : "Weekly",
  }
],
  Incentive_Calculation_Type:[{
     value : "Sales",
    description : "The incentive points will be calculated once the order is converted into sales.Negative sales , rejected orders, unfulfilled orders will not be considered."
  },
  {
    value : "Order",
    description : "The incentive points will be calculated when the order is synced , Order rejected from app will not be considered."
  }
  ],
  Coupon_Type_Options: [
    {
      value: COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON,
      description:
        "This type allows you to create a coupon applicable on individual item levels among items in the product universe",
    },
    {
      value: COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE,
      description:
        "This type allows you to create a coupon with multiple SKUs and provide a discount basis final order value",
    },
    {
      value: COUPON_TYPE_OPTIONS_VALUE.BUNDLE,
      description: "This type allows you to create a coupon on group of SKUs",
    },
    {
      value: COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE,
      description: `This type allows you to create a coupon that provides discount basis final order value.`,
    },
    {
      value: COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME,
      description: `This type allows you to create a coupon that provides discount basis final order value applied only once lifetime`,
    },
  ],
  Calculation_Method_Options: [
    {
      value: "percentage",
    },
    {
      value: "value",
    },
  ],
  Recurrence_Options: [
    { "DefineNthPurchase": true }, { "Usability": true }, { "ActivePeriod": true, "NDays":true  } , { "ActiveTime": true }
  ],
  "schemePlayground" : "false",
  "LocationFilter" : "true",
  "OverAndAbove" : "true",
  "piece" : "true",
  "Large_Exclusions":"false",
  "onlyDateUpdate": "false",
  "persistFilters":"false",
  "SortByDefault": "false",
  "case" : "true",
  "Inclusion" : "true",
  "Exclusion" : "true",
  "CouponTitleRequired" : "true",
  "showSkipMarketDetails":"true",
  "banner_upload":"true",
  "selectAll":"true",
  "version":"V2",
  Coupon_Step_Options: [
      "Define Coupons",
      "Campaign Goals",
      "Budget Planning",
      "Create Banner",
      "Coupon Summary",
  ],
  Coupon_Case_Number: {},
  LiveCoupon_Excluded_Headers: [
  ],
  Coupon_Filters: [
    "schemeId", 
    "activeStatus"
  ],
  USABILITY_PERIOD_ARRAY: ["Daily", "Weekly", "Monthly", "Quarterly"],
  MakeOnceCheckBox: false,
  "IsPeriodicWelcome":"true",
  "showDistributorDesignation":"false",
  removeEntites:[
    "customGroupCode",
    "itemClass"
 ]
};

export function updateMetaData(toBeAdded: object) {
  MetaData = {
    ...MetaData,
    ...toBeAdded,
  };
  let caseNumber = 0;
  for (const step of MetaData.Coupon_Step_Options) {
    MetaData.Coupon_Case_Number[step] = caseNumber;
    caseNumber++;
  }
}

export const steps = [
  "Define Coupons",
  "Campaign Goals",
  "Budget Planning",
  "Create Banner",
  "Coupon Summary",
];

/**
 * enities to be removed from api data
 */
export const removeEntites = [
   "customGroupCode",
   "itemClass"
]

export const DEBOUNCING_DELAY = 500;
export const ALL = "ALL";
export const ALL_COLUMNS_OF_PRODUCT_SLAB_ALL = "ALL_COLUMNS_ALL";
export const INVALID = "INVALID";
export const VALID = "VALID";
export const INVALID_EMPTY_DATA = "EMPTY_DATA";
export const INVALID_BATCHCODE_OVERLAPPING = "OVERLAPPING";
export const INVALID_RANGE_OVERLAPPING = "OVERLAPPING";
export const INVALID_SLAB_FIELD = "INVALID_SLAB_FIELD";
export const INVALID_INCLUSION_LIST_RESET = "INVALID_INCLUSION_LIST_RESET";
export const ALL_COLUMNS_OF_MARKET_DETAILS_SLAB_ALL = "ALL_COLUMNS_OF_MARKET_DETAILS_SLAB_ALL";

export const INVALID_ALL_COLUMN_ALL_IN_ILC = "INVALID_ALL_COLUMN_ALL_IN_ILC"

// enter lowercase
export let ENTITY_PRIORITY:Record<string,number> ={
    itemclass:0,
    category:1,
    brand:2,
    piecesize:4,
    piecesizedesc:5,
    flavour:3,
    batchcode:6,
    region:0,
    state:1,
    district:2,
    town:3,
    distributordetails:8,
    supplier:5,
    salesmanager:6,
    asm:6,
    outlettype:7,
    channel:5,
    vpoclass:9,
    outletcode:10,
    marketid:11
}

export function updateEntityPriorities(tobeAdded: object) {
  ENTITY_PRIORITY = {
    ...ENTITY_PRIORITY,
    ...tobeAdded,
  };
}

export const getApplicableSlabsInputs = () => [
  {
    id: "start-range",
    name: "Start Range",
    components: [
      {
        type: "textField",
        props: {
          required: true,
          // type: "number",
          placeholder: "start qty/amount for this slab",
          name: "start-range",
        },
      },
    ],
  },
  {
    id: "end-range",
    name: "End Range",
    placeholder: "Write here",
    components: [
      {
        type: "textField",
        props: {
          required: true,
          // type: "number",
          placeholder: "end qty/amount for this slab",
          name: "end-range",
        },
      },
    ],
  },
  {
    id: "discount-offered",
    name: "Discount Offered",
    placeholder: "Write here",
    components: [
      {
        type: "textField",
        props: {
          required: true,
          // type: "number",
          placeholder: "Discount value",
          name: "discount-offered",
        },
      },
    ],
  },
  {
    id: "final-order-value",
    name: "Final Order Value",
    placeholder: "Min Amount",
    components: [
      {
        type: "textField",
        props: {
          required: true,
          type: "number",
          placeholder: "Min Amount",
          name: "final-order-value",
        },
      },
    ],
  },
  {
    id: "coupon-description",
    name: labelMappings["coupon-description-name"],
    placeholder: labelMappings["coupon-description-placeholder"],
    components: [
      {
        type: "textField",
        props: {
          required: true,
          type: "text",
          placeholder: labelMappings["coupon-description-placeholder"],
          name: "coupon-description",
        },
      },
    ],
  },
];

export const APPLICABLE_SLABS_INPUTS = getApplicableSlabsInputs();

export const COLUMN_NAME_MAP_DB_COLUMN_NAME_FOR_VALID_OUTLET: Record<
  string,
  string
> = {
  outletType: "outletType",
  channel: "channel",
  distributorDetails: "loginid",
  asm: "distributionChannel",
  vpoClass: "outletClass",
  outletCode: "outletcode",
};

export const COLUMN_NAME_MAP_DB_COLUMN_NAME: Record<string, string> = {
    "outletType": "outletType",
    "channel": "channel",
    "distributorDetails": "loginId",
    "state": "state",
    "town": "town",
    "district": "district",
    "region": "region",
    "asm": "distributionChannel",
    "vpoClass": "outletClass",
    "outletClass": "outletClass",
    "marketId": "marketId",
    "outletCategory" : "outletCategory",
    "subChannel": "subChannel"
}

export const DB_COLUMN_NAME_MAP_COLUMN_NAME:Record<string,string>={
    "outletType":"outletType",
    "channel":"channel",
    "supplier":"distributorDetails",
    "state":"state",
    "town":"town",
    "district":"district",
    "region":"region",
    "distributionChannel":"asm",
    "outletClass":"outletClass",
    "outletcode":"outletCode",
    "loginId" : "distributorDetails",
    "outletCode":"outletCode",
    "marketId":"marketId",
    "marketName":"marketName",
    "subTerritory":"subTerritory",
    "subChannel":"subChannel",
    "outletCategory":"outletCategory",
    "outletDivision":"outletDivision",
}

export const ID_MAP_API_REQUEST_FIELD: Record<string, string> = {
  "coupon-description": "schemeDescription",
  "discount-offered": "schemeBenefit",
  "end-range": "endRange",
  "final-order-value": "minimumAmount",
  "start-range": "startRange",
  min_qty: "qty",
};

export const LAST_TAB = 3;

export const CHANNEL_NAME_MAP_CHANNEL_CODE: Record<string, string> = {
  "E AND D 2": "012",
  EDUCATION: "013",
  "AT-WORK": "016",
  ENTERTAINMENT: "018",
  TRANSPORTATION: "019",
  CONVENIENCE: "021",
  "Grocery 1": "033",
  Wholesale: "036",
  Petro: "038",
  "Grocery 2": "039",
  Pharma: "041",
  BOP: "049",
  CINEMA: "050",
  "E and D 1": "051",
  INSTITUTIONS: "053",
  "MODERN TRADE": "054",
  OTHERS: "099",
  "Coke2Home":"055",
  "TPT RAIL":"064",
  "Paan/Cigarette shop":"081",
};

export const ACCEPTED_INCLUSION_EXCLUSION_FILE_TYPES = ["xlsx"]
  .map(function (x) {
    return "." + x;
})
    .join(",");

export const ID_MAP_EXTRA_FIELDS = {
  product: [
    "batchCode",
    "brand",
    "category",
    "itemClass",
    "itemId",
    "pieceSize",
    "subCategory",
    "customGroupCode",
    "ctg",
    "flavour",
    "marketSku",
    "pieceSizeDesc",
    "purchaseUnit",
    "size",
    "subCategoryCode",
  ],
  outlet: [
    "channel",
    "loginId",
    "outletCategory",
    "outletCode",
    "outletType",
    "subChannel",
    "distributionChannel",
    "account",
    "outletClass",
    "marketId",
    "marketName",
    "subTerritory",
    "soldTo",
    "outletDivision",
    "priceListId",
  ],
  location: [
    "city",
    "country",
    "region",
    "schemeLocationId",
    "state",
    "town",
    "district",
  ],
};

export const POST_NULL_CHECKS = [
    { field: "schemeId" },
    { field: "schemeType" },
    { field: "startDate" },
    { field: "endDate" },
    { field: "schemeDescription" },
    { field: "extendedAttributes" },
    { field: "programLevel" },
    { field: "priority" },
    { field: "schemeCalculation.schemeType" },
    { field: "schemeCalculation.schemeId" },
    { field: "schemeCalculation.criteria" },
    { field: "schemeCalculation.rangeLevelUnit" },
    { field: "schemeCalculation.itemEach" },
    { field: "schemeCalculation.forEach" },
    { field: "schemeCalculation.slabInfo" },
    { field: "schemeCalculation.maxDiscount",shouldNotBe:[null]}
];

export const POST_SchemeLocationBifurcationsList_CHECKS = [
  { field: "region" },
  { field: "schemeId" },
  { field: "state" },
  { field: "district" },
  { field: "town" },
  { field: "city" },
  { field: "country" },
  { field: "schemeLocationId" },
];

export const POST_SchemeOutletBifurcationsList_CHECKS = [
  { field: "channel" },
  { field: "schemeId" },
  { field: "distributionChannel" },
  { field: "loginId" },
  { field: "outletCode" },
  { field: "outletCategory" },
  { field: "outletType" },
  { field: "subChannel" },
  { field: "account" },
  { field: "outletClass" },
  { field: "marketId" },
  { field: "marketName" },
  { field: "subTerritory" },
  { field: "soldTo" },
  { field: "outletDivision" },
];

export const POST_SchemeProductBifurcationsList_CHECKS = [
  { field: "itemClass" },
  { field: "schemeId" },
  { field: "brand" },
  { field: "pieceSize" },
  { field: "pieceSizeDesc" },
  { field: "batchCode" },
  { field: "category" },
  { field: "itemId" },
  { field: "subCategory" },
  { field: "customGroupCode" },
  { field: "ctg" },
  { field: "flavour" },
  { field: "marketSku" },
  { field: "purchaseUnit" },
  { field: "size" },
  { field: "subCategoryCode" },
];

export const POST_SLAB_INFO_CHECKS = [
  { field: "schemeDescription" },
  { field: "schemeBenefit" },
  { field: "endRange" },
  { field: "startRange" },
];

export const inPlaygroundMode = "inPlaygrondMode";

export const couponTitlePrefix : any = {
  "item_level_coupon": "ILC",
  "bundle_+_total_order_value": "BTOV",
  "bundle": "BILC",
  "total_order_value": "TOV",
  "total_order_welcome": "TOW",
}

export const MONTHS = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" }

];
export const WEEKS = [
    { value: "Week 1", label: "Week 1" },
    { value: "Week 2", label: "Week 2" },
    { value: "Week 3", label: "Week 3" },
    { value: "Week 4", label: "Week 4" },
    { value: "Week 5", label: "Week 5" },
    { value: "Week 6", label: "Week 6" }
];
export const DAYS = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
];